import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const ClassificationForm = ({ currentForm }) => {
  const [classification, setClassification] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const classificationsPerPage = 10;
  const [selectedClassificationLocal, setSelectedClassificationLocal] =
    useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    nombreClassification: "",
    descripcionClassification: "",
    estatusClassification: "activo",
  });

  const openModal = (classification) => {
    setSelectedClassificationLocal(classification); // Configura el classification seleccionado para la edición

    if (classification) {
      setIsEditing(true); // Establecer como modo edición cuando se abre el modal
      setFormulario({
        nombreClassification: classification.classificationNm,
        descripcionclassification: classification.classificationDesc,
        estatusClassification: classification.estatus ? "activo" : "inactivo",
      });
    } else {
      setIsEditing(false); // Establecer como modo creación cuando se abre el modal para crear uno nuevo
      // Limpia los campos si es necesario
      setFormulario({
        nombreClassification: "",
        descripcionclassification: "",
        estatusClassification: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedClassificationLocal(null); // Limpia el classification seleccionado
    setIsEditing(false); // Resetear el modo edición cuando se cierra el modal
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Iniciar la carga
      try {
        const response = await medicGeekApi.get(
          `/classifications?search=${searchTerm}`,
          {
            params: {
              $or: [
                { classificationNm: { $regex: searchTerm, $options: "i" } },
                { classificationDesc: { $regex: searchTerm, $options: "i" } },
              ],
            },
          }
        );
        const sortedClassifications = response.data.sort(
          (a, b) => a.classificationId - b.classificationId
        );
        setClassification(sortedClassifications);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar carga
      }
    };

    fetchData();
  }, [searchTerm]);

  const pageCount = Math.ceil(classification.length / classificationsPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedClassifications = classification
    .filter((classification) => {
      // Filtrar classifications basados en el término de búsqueda
      return (
        classification.classificationNm
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        classification.classificationDesc
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    })
    .slice(
      pageNumber * classificationsPerPage,
      (pageNumber + 1) * classificationsPerPage
    );

  const updateClassificationForm = () => {
    medicGeekApi
      .get("/classifications")
      .then((response) => {
        setClassification(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const guardarNuevoClassification = () => {
    const nuevoClassification = {
      classificationNm: document.getElementById("nombreClassification").value,
      classificationDesc: document.getElementById("descripcionClassification")
        .value,
      estatus:
        document.getElementById("estatusClassification").value === "activo"
          ? "Activo"
          : "Inactivo",
    };
    medicGeekApi
      .post("/classifications", nuevoClassification)
      .then((response) => {
        showSuccessAlert();
        closeModal();
        updateClassificationForm();
      })
      .catch((error) => {
        console.error("Error al crear el Classification", error);
      });
  };

  const editarClassification = () => {
    if (
      selectedClassificationLocal &&
      selectedClassificationLocal.classificationId
    ) {
      const { classificationId } = selectedClassificationLocal;
      const nombreClassification = document.getElementById(
        "nombreClassification"
      ).value;
      const descripcionClassification = document.getElementById(
        "descripcionClassification"
      ).value;
      const estatusClassification =
        document.getElementById("estatusClassification").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedClassification = {
        classificationId, // Asegurarse de enviar el ID
        classificationNm: nombreClassification,
        classificationDesc: descripcionClassification,
        estatus: estatusClassification,
      };

      medicGeekApi
        .patch(`/classifications/${classificationId}`, updatedClassification)
        .then((response) => {
          showSuccessEditAlert();
          closeModal();
          updateClassificationForm();
        })
        .catch((error) => {
          console.error("Error al actualizar el Classification", error);
        });
    } else {
      // Manejo de error o mensaje de que no se puede actualizar
      showErrorAlert("No se puede actualizar: Classification no válido.");
    }
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
    </tr>
  );

  return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h2 className="pro-title">
          Clasificación
        </h2>

        <p className="pro-subtitle">
          Gestión y mantenimiento de clasificaciones
        </p>

      </div>

      <div className="pro-actions">

        {/* SEARCH */}
        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar clasificación..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        {/* BUTTON */}
        <button
          type="button"
          className="pro-btn-primary"
          title="Crear Nueva Clasificación"
          onClick={() => openModal(null)}
        >
          <i className="bi bi-file-plus"></i>

          Nueva Clasificación
        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table align-middle">

          <thead>

            <tr>

              <th style={{ width: "8%" }}>
                ID
              </th>

              <th style={{ width: "25%" }}>
                Nombre
              </th>

              <th style={{ width: "40%" }}>
                Descripción
              </th>

              <th style={{ width: "12%" }}>
                Estatus
              </th>

              <th
                className="text-center"
                style={{ width: "15%" }}
              >
                Acciones
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              Array.from({ length: 15 }).map((_, index) => (

                <tr key={index}>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                </tr>

              ))

            ) : (

              displayedClassifications.map((classification) => (

                <tr key={classification.classificationId}>

                  {/* ID */}
                  <td>

                    <span className="expediente-badge">
                      #{classification.classificationId}
                    </span>

                  </td>

                  {/* NAME */}
                  <td>

                    <div className="fw-semibold">

                      {classification.classificationNm}

                    </div>

                  </td>

                  {/* DESCRIPTION */}
                  <td
                    className="truncate-text"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={classification.classificationDesc}
                  >

                    {classification.classificationDesc?.length > 45
                      ? `${classification.classificationDesc.slice(0, 45)}...`
                      : classification.classificationDesc}

                  </td>

                  {/* STATUS */}
                  <td>

                    <span
                      className={`gender-badge ${
                        classification.estatus === "Activo"
                          ? ""
                          : "opacity-75"
                      }`}
                    >
                      {classification.estatus}
                    </span>

                  </td>

                  {/* ACTIONS */}
                  <td>

                    <div className="pro-table-actions">

                      {/* EDIT */}
                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Editar"
                        onClick={() => openModal(classification)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>

                      {/* DELETE */}
                      <button
                        type="button"
                        className="pro-action-btn info"
                        title="Eliminar"
                      >
                        <i className="bi bi-trash"></i>
                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row g-3">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div
              className="col-12"
              key={index}
            >

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedClassifications.map((classification) => (

            <div
              className="col-12"
              key={classification.classificationId}
            >

              <div className="mobile-patient-card">

                {/* TOP */}
                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div className="patient-avatar">

                      {classification.classificationNm?.charAt(0)}

                    </div>

                    <div>

                      <div className="patient-name">

                        {classification.classificationNm}

                      </div>

                      <div className="patient-id">

                        ID #{classification.classificationId}

                      </div>

                    </div>

                  </div>

                </div>

                {/* CONTENT */}
                <div className="mobile-card-content">

                  <p>

                    <strong>Descripción:</strong><br />

                    {classification.classificationDesc}

                  </p>

                  <p>

                    <strong>Estatus:</strong><br />

                    <span className="gender-badge">

                      {classification.estatus}

                    </span>

                  </p>

                </div>

                {/* ACTIONS */}
                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    onClick={() => openModal(classification)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    type="button"
                    className="pro-action-btn info"
                  >
                    <i className="bi bi-trash"></i>
                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav>

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}
            <li
              className={`page-item ${
                pageNumber === 0
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
              >
                <i className="bi bi-chevron-left"></i>
              </button>

            </li>

            {/* NUMBERS */}
            {Array.from(
              {
                length: Math.min(pageCount, 10),
              },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <button
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >
                    {index + 1}
                  </button>

                </li>

              )
            )}

            {/* NEXT */}
            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
              >
                <i className="bi bi-chevron-right"></i>
              </button>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Clasificación"
          : "Crear Nueva Clasificación"}

      </ModalHeader>

      <ModalBody>

        <Form className="pro-form">

          {/* NAME */}
          <FormGroup floating className="mb-4">

            <Input
              type="text"
              id="nombreClassification"
              className="pro-input"
              placeholder="Nombre"
              value={formulario.nombreClassification}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreClassification: e.target.value,
                })
              }
            />

            <Label for="nombreClassification">
              Nombre de la Clasificación
            </Label>

          </FormGroup>

          {/* DESCRIPTION */}
          <FormGroup floating className="mb-4">

            <Input
              type="textarea"
              id="descripcionClassification"
              className="pro-input"
              placeholder="Descripción"
              value={formulario.descripcionClassification}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  descripcionClassification: e.target.value,
                })
              }
            />

            <Label for="descripcionClassification">
              Descripción
            </Label>

          </FormGroup>

          {/* STATUS */}
          <FormGroup floating>

            <Input
              type="select"
              id="estatusClassification"
              className="pro-input"
              value={formulario.estatusClassification}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusClassification: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

            <Label for="estatusClassification">
              Estado
            </Label>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter className="border-0 pt-0">

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >
          Cancelar
        </Button>

        <Button
          className="pro-btn-save"
          onClick={
            isEditing
              ? editarClassification
              : guardarNuevoClassification
          }
        >
          {isEditing
            ? "Guardar Edición"
            : "Guardar"}
        </Button>

      </ModalFooter>

    </Modal>

  </div>
  );
};
export default ClassificationForm;
